import { render, staticRenderFns } from "./classStudy.vue?vue&type=template&id=2e78e853&scoped=true&"
import script from "./classStudy.vue?vue&type=script&lang=js&"
export * from "./classStudy.vue?vue&type=script&lang=js&"
import style0 from "./classStudy.vue?vue&type=style&index=0&id=2e78e853&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e78e853",
  null
  
)

export default component.exports